import { Box, Menu, MenuItem, MenuProps, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
    MarkdownConverter,
    PoolButton,
    PoolFormattedRelativeTime,
    PoolLineClampTypography,
    PoolTypography,
} from '@synergy/components-next';
import { MouseEvent, ReactElement } from 'react';
import { useNavigate } from 'react-router';

import { newsSliderItemSelector } from '../../../../store/news-selectors';
import { useAppSelector } from '../../../../../store/store';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(1.5, 2),
}));

type NewsMenuProps = MenuProps;

export const NewsMenu = (props: NewsMenuProps): ReactElement => {
    const { ...menuProps } = props;
    const { news } = useAppSelector(newsSliderItemSelector);
    const navigate = useNavigate();

    const handleAllNewsClick = (e: MouseEvent<HTMLButtonElement>): void => {
        navigate('/news');
        props.onClose?.(e, 'backdropClick');
    };

    const handleSingleNewsClick = (e: MouseEvent<HTMLLIElement>, id: number): void => {
        navigate(`/news/${id}`);
        props.onClose?.(e, 'backdropClick');
    };

    return (
        <Menu {...menuProps} PaperProps={{ sx: { width: 375 } }} disableAutoFocusItem={true}>
            {news.slice(0, 3).map(({ id, title, text, publishAt }, index) => (
                <StyledMenuItem key={index} onClick={e => handleSingleNewsClick(e, id)}>
                    <PoolTypography variant="subtitle2">{title}</PoolTypography>
                    <PoolLineClampTypography variant="body2" maxLines={2}>
                        <MarkdownConverter value={text} />
                    </PoolLineClampTypography>
                    <PoolTypography variant="caption" color="grey.800">
                        <PoolFormattedRelativeTime value={publishAt} />
                    </PoolTypography>
                </StyledMenuItem>
            ))}
            <Box p={2}>
                <PoolButton variant="outlined" color="dark" fullWidth={true} onClick={handleAllNewsClick}>
                    <FormattedMessage id="app.header.allNews" />
                </PoolButton>
            </Box>
        </Menu>
    );
};
